module.exports = __webpack_public_path__ + "static/media/census-horizontal.af908a49.jpg";